import { trackEvent } from "@faire/web--source/common/trackEvent";
import deleteFollowsBrand from "@faire/web-api--source/api/v2/retailers/retailerToken/follows/brandToken/delete";
import postFollowsBrand from "@faire/web-api--source/api/v2/retailers/retailerToken/follows/brandToken/post";

import { showBrandFollowToast } from "@faire/retailer-visitor-shared/features/RetailerBoards/Components/BrandFollowToast";
import { getRetailerToken } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

export const followBrand = async (
  brandToken: string,
  brandName: string | undefined
) => {
  await postFollowsBrand(getRetailerToken(), brandToken);
  showBrandFollowToast(brandName);
};

export const unFollowBrand = (brandToken: string) => {
  deleteFollowsBrand(getRetailerToken(), brandToken);
};

export const trackBoardsEvent = (eventName: string) => {
  trackEvent(`retailer/${getRetailerToken()}/boards/${eventName}`);
};
